module.exports = __webpack_public_path__ + "static/media/aboutUs4.51da0e4b.jpg";